var render = function render(){var _vm=this,_c=_vm._self._c;return _c('polygon',{attrs:{"points":"13,10 18,10 21,7 18,4 13,4 13,2 11,2 11,4 4,4 4,10 11,10 11,12 6,12 3,15 6,18 11,18 11,22 13,22 13,18 20,18 20,12 13,12"}})
}
var staticRenderFns = []

export { render, staticRenderFns }